import { z } from "zod";
import { metaSchema, sortBySchema } from "./commun.zod";

export const NuisibleBaseSchema = z.object({
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
});

export const NuisibleSchema = NuisibleBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const NuisibleCreateSchema = NuisibleBaseSchema.pick({
  name: true,
});

export const NuisibleUpdateSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
});

export const NuisibleListResponseSchema = z.object({
  data: z.array(NuisibleSchema),
  meta: metaSchema
});

export const NuisibleResponseSchema = z.object({
  data: NuisibleSchema,
  message: z.string().optional(),
});

export const NuisibleSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().optional(),
  limit: z.number().default(10),
  page: z.number().default(1),
  search: z.string().optional(),
  sortBy: sortBySchema
});

export type Nuisible = z.infer<typeof NuisibleSchema>;
export type NuisibleCreateInput = z.infer<typeof NuisibleCreateSchema>;
export type NuisibleUpdateInput = z.infer<typeof NuisibleUpdateSchema>;
export type NuisibleSelectInput = z.infer<typeof NuisibleSelectSchema>;

// Form-specific types for frontend
export type NuisibleFormData = NuisibleCreateInput;

export type NuisibleEditFormData = Omit<NuisibleUpdateInput, 'id'>;

// Utility types for different UI states
export type NuisibleDisplayItem = Pick<Nuisible, 'id' | 'name'>;
export type NuisibleSelectOption = Pick<Nuisible, 'id' | 'name'>;
export type NuisibleTableItem = Pick<Nuisible, 'id' | 'name' | 'created_at' | 'updated_at'>;

export type NuisibleResponse = z.infer<typeof NuisibleResponseSchema>;
export type NuisibleListResponse = z.infer<typeof NuisibleListResponseSchema>;

export const validateNuisibleCreate = (data: unknown) => {
  return NuisibleCreateSchema.safeParse(data);
};

export const validateNuisibleUpdate = (data: unknown) => {
  return NuisibleUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateNuisibleSelect = (data: unknown) => {
  return NuisibleSelectSchema.safeParse(data);
};
